module.exports = require("devalue");